<template>
  <div class="custom-page-box">
    <a-card title="成员列表" :bordered="false" :headStyle="{fontSize:'18px'}">
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="['search_name','search_phone','search_shop_name','search_state','search_selectedDate','search_transactionDate','search_group','search_btns']"
        :columns="getColumns()"
        :queryParams="queryParams"
        row-key="staffId"
        :leftSpace="30"
        :enableSearch='false'
        :customPagination="true"
        extraPaginationName="extraPaginationName"
        :requestPromise="getMemberListPromise"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <a-form-item slot="search_name" label="姓名" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staffName" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_phone" label="手机号" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staffMobile" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_shop_name" label="店铺名称" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staffShopName" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_state" label="状态" v-bind="searchItemLayout">
          <a-select
            v-model="queryParams.staffStatus"
            placeholder="请输入"
            style="width: 100%">
            <a-select-option v-for="(item,index) in staffStatusList" :value="item.staffStatus" :key="index">
              {{ item.staffStatusName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item slot="search_selectedDate" label="注册时间" v-bind="searchItemLayout">
          <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_transactionDate" label="交易时间" v-bind="searchItemLayout">
          <a-range-picker @change="onDateTransactionChange" :value="transactionDate" style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_group" label="分组名称" v-bind="searchItemLayout">
          <a-select
            v-model="queryParams.groupIds"
            mode="multiple"
            placeholder="请选择"
            option-label-prop="label"
            style='width: 100%;'
            @change="handleGroupChange"
          >
            <a-select-option v-for="item in groupArrList" :key="item.id" :value="item.id" :label="item.name">
              <span role="img" :aria-label="item.name">{{ item.name }}</span>
            </a-select-option>
          </a-select>
          <!--          <a-row :gutter="8">-->
          <!--            <a-col :span="12">-->
          <!--              <a-select v-model="queryParams.groupChoose" placeholder="请选择"-->
          <!--                        style='width: 100%;' @change='changeSelect'>-->
          <!--                <a-select-option :value="0">全部</a-select-option>-->
          <!--                <a-select-option :value="1">有分组</a-select-option>-->
          <!--                <a-select-option :value="2">无分组</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-col>-->
          <!--            <a-col :span="12" v-if='queryParams.groupChoose==1'>-->
          <!--              <a-input v-model.trim="queryParams.groupName" placeholder="请输入"/>-->
          <!--            </a-col>-->
          <!--          </a-row>-->
        </a-form-item>
        <a-form-item slot="search_btns" v-bind="searchItemLayout" style='margin-left:3%'>
          <a-button type="primary" @click='onclickQuery'>查询</a-button>
        </a-form-item>
<!--        <a-form-item slot="operation">-->
<!--          <div style='margin-bottom: 10px;'>-->
<!--            <a-button style="margin-left: 20px" ghost type="primary" icon="plus" @click="createMemberEvent">添加成员-->
<!--            </a-button>-->
<!--            <a-button style="margin-left: 20px" ghost type="primary" icon="plus" @click="submitMemberAuthEvent">提交成员认证-->
<!--            </a-button>-->
<!--            <span style="float: right">成员前端注册资料 <a style="padding-left: 10px"-->
<!--                                                           @click="settingEvent">设置</a></span>-->
<!--          </div>-->
<!--          <a-row class="status-list-custom">-->
<!--            <a-col :xs="6" :sm="6">-->
<!--              <div class="text">销售统计</div>-->
<!--              <div class="heading">{{ totalForm.totalPaidFeeCount }}</div>-->
<!--            </a-col>-->
<!--            <a-col :xs="6" :sm="6">-->
<!--              <div class="text">累计提现金额</div>-->
<!--              <div class="heading"><span>{{ totalForm.totalAccountWithdrawn }}</span><i>元</i></div>-->
<!--            </a-col>-->
<!--            <a-col :xs="6" :sm="6">-->
<!--              <div class="text">可提现金额</div>-->
<!--              <div class="heading"><span class="active">{{ totalForm.totalAccountAbleDrawCash }}</span> <i>元</i></div>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-form-item>-->
        <template slot='group' slot-scope="rowItem">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ rowItem.record.groupName }}</template>
            <div class="pro_title">{{ rowItem.record.groupName }}</div>
          </a-tooltip>
        </template>
        <div slot="contactSlots" slot-scope="rowItem">
          <div>{{ rowItem.record.staffName }}</div>
          <div>{{ rowItem.record.staffMobile }}</div>
        </div>
        <span slot="memberState" slot-scope="rowItem">
          <template v-if="rowItem.record.staffAudit===1">
              <span>{{ rowItem.record.staffStatus|staffStatusName }}</span>
          </template>
          <template v-else>{{ rowItem.record.staffAudit|staffAuditName }}</template>
        </span>
        <span slot="action" slot-scope="rowItem">
<!--          <a @click="toDetailEvent(rowItem.record)">资料详情</a>-->
<!--          <a-divider type="vertical"></a-divider>-->
          <a @click="toAuthDetailEvent(rowItem.record)">认证详情</a>
          <a-divider type="vertical"></a-divider>
          <a @click="toRecordEvent(rowItem.record)">佣金记录</a>
          <template v-if="rowItem.record.staffAudit===0">
            <a-divider type="vertical"></a-divider>
            <a @click="auditEvent(rowItem.record)">审核</a>
          </template>
          <template
            v-else-if="rowItem.record.staffAudit===1 &&(rowItem.record.staffStatus===0||rowItem.record.staffStatus===1) ">
            <a-divider type="vertical"></a-divider>
            <a-popconfirm
              :title="'是否要'+(rowItem.record.staffStatus===0?'启用':'禁用')+'当前成员'"
              @confirm="updateStatus(rowItem.record)">
              <a>{{ rowItem.record.staffStatus === 0 ? '启用' : '禁用' }}</a>
            </a-popconfirm>
          </template>
        </span>
        <div slot="extraPaginationName" v-if='selectedRowKeys&&selectedRowKeys.length>0'>
          <span>已选择 {{ selectedRowKeys.length }} 项</span>
          <a-button class="ml10" @click="showGroupDialogEvent">分组</a-button>
        </div>
      </search-page-view>
      <!-- 原审核弹窗，现改为跳转成员认证详情页审核
      <a-modal title="审核" :width="800" v-model="showAuditDialog" @ok="handleAudit" @cancel="showAuditDialog=false">
        <a-form :form="form">
          <a-form-item label="" v-bind="searchItemLayout">
            <a-radio-group @change="onAuditStateChange"
                           v-decorator="['staffAudit', {rules:[{required: true, message:'请选择状态'}]}]">
              <a-radio :value="1">通过</a-radio>
              <br/>
              <a-radio :value="2">拒绝</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="" v-bind="searchItemLayout">
            <a-textarea
              v-if="staffAudit===2"
              v-decorator="['auditRemark', {rules:[{required: true, message:'请输入原因'}]}]"
              placeholder="请输入原因"
              :rows="4"
            ></a-textarea>
          </a-form-item>
        </a-form>
      </a-modal>
      -->
      <!-- 分组弹窗 -->
      <selected-product-dialog
        title='选择分组'
        :show="showSelectedDialog"
        ref="pageDialogList"
        row-key="id"
        :itemNames="['search_groupName']"
        :query-params="selectedQueryParams"
        :requestPromise="loadGroupPromise"
        :enableSearch="false"
        :rowSelection="{ selectedRowKeys: selectedGroupRowKeys, onChange: onGroupChange }"
        @close="showSelectedDialog=false"
        :columns="getGroupColumns()"
      >
        <a-form-item slot="search_groupName" style="margin-bottom: 10px">
          <a-input-search v-model="selectedQueryParams.name" placeholder="请输入分组名称" @search="onGroupSearch"/>
        </a-form-item>
        <div class='footer-btns' slot='footer'>
          <a-button @click="closeClick">取消</a-button>
          <a-button class='ml10' type="primary" @click="createOkEvent">确定</a-button>
        </div>
      </selected-product-dialog>
    </a-card>
  </div>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'MemberList',
  mixins: [searchForm],
  components: { SelectedProductDialog },
  data() {
    return {
      showSelectedDialog: false,
      selectedQueryParams: {
        name: ''
      },
      queryParams: {
        staffName: '',
        staffMobile: '',
        staffShopName: '',
        staffStatus: null,
        createStartTime: '',
        createEndTime: '',
        dealStartTime: '',
        dealEndTime: '',
        groupChoose: 0,
        groupName: '',
        orderByPaidFeeCount: '',
        orderByAccountWithdrawn: '',
        orderByAccountAbleDrawCash: '',
        groupIds: []
      },
      selectedDate: null,
      transactionDate: null,
      // form: this.$form.createForm(this),
      // showAuditDialog: false,
      // selectedItem: undefined,
      staffStatusList: [],
      // staffAudit: 1,
      selectedRowKeys: [],
      totalForm: {
        totalPaidFeeCount: 0,
        totalAccountWithdrawn: 0,
        totalAccountAbleDrawCash: 0
      },
      isFixed: true,
      selectedGroupRowKeys: [],
      groupArrList: []
    }
  },
  created() {
  },
  mounted() {
    this.getStaffStatus()
    this.getGroupListPromise()
    this.customPaginationTop = this.$refs.pageList.$refs.table.$refs.customPaginationTop.offsetTop
    this.getLogUtils().logWithTag('customPaginationTop', this.customPaginationTop)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == 'CreateMember' || from.name == 'MemberAuthDetail' || from.name == 'SubmitMemberAuth') {
        vm.timeOut()
      }
    })
  },
  activated() {
    window.addEventListener('scroll', this.handleScroll)
  },
  deactivated() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleGroupChange(value) {
      this.getLogUtils().logWithTag('handleGroupChange', value)
    },
    getGroupListPromise() {
      const params = {
        limitDto: {
          pageNum: 1,
          pageSize: 1000
        }
      }
      this.getHttpServices().getUserService().post('merchant/v2/group/getGroupList', params).then(res => {
        this.getLogUtils().errorWithTag('getGroupListPromise', res)
        if (res && res.data && res.data.length > 0) {
          this.groupArrList = res.data
        }
      }).catch(err => {
        this.getLogUtils().errorWithTag('getGroupListPromise', err)
      })
    },
    onclickQuery() {
      if (this.queryParams.groupChoose == 1) {
        if (!this.queryParams.groupName) {
          this.$message.error('请输入分组名称')
        } else {
          this.$refs.pageList.refresh(true)
        }
      } else {
        this.$refs.pageList.refresh(true)
      }
    },
    onGroupSearch() {
      this.$refs.pageDialogList.refresh(true)
    },
    closeClick() {
      this.showSelectedDialog = false
    },
    onGroupChange(selectedRowKeys, selectedRows) {
      this.selectedGroupRowKeys = selectedRowKeys
      this.getLogUtils().errorWithTag('onSelectChange', this.selectedGroupRowKeys)
      this.getLogUtils().errorWithTag('onSelectChange', selectedRows)
    },
    loadGroupPromise(params) {
      this.getLogUtils().logWithTag('params+++++++++++++++++', params)
      return this.getHttpServices().getUserService().post('merchant/v2/group/getManualControlGroupList', params)
    },
    createOkEvent() {
      if (this.selectedGroupRowKeys && this.selectedGroupRowKeys.length > 0) {
        this.submitGroupData()
      } else {
        this.$message.error('至少勾选一项')
      }
    },
    submitGroupData() {
      const params = {
        groupIds: this.selectedGroupRowKeys,
        staffIds: this.selectedRowKeys
      }
      this.getHttpServices().getUserService().post('staff/v2/markBatchStaffGroup', params).then(res => {
        this.$message.success('保存成功')
        this.showSelectedDialog = false
        this.selectedRowKeys = []
        this.timeOut()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop //变量windowHeight是可视区的高度
      // this.getLogUtils().logWithTag('scrollTop', scrollTop)
      this.isFixed = this.customPaginationTop > scrollTop ? true : false
    },
    showGroupDialogEvent() {
      this.showSelectedDialog = true
      this.selectedGroupRowKeys = []
    },
    changeSelect(value) {
      this.getLogUtils().logWithTag('==changeSelect==', value)
      this.queryParams.groupName = ''
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.getLogUtils().errorWithTag('onSelectChange', this.selectedRowKeys)
      this.getLogUtils().errorWithTag('onSelectChange', selectedRows)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.createStartTime = dateStrArr[0]//开始日期
      this.queryParams.createEndTime = dateStrArr[1]//结束日期
    },
    onDateTransactionChange(dates, dateStrArr) {
      this.transactionDate = dates
      this.queryParams.dealStartTime = dateStrArr[0]//开始日期
      this.queryParams.dealEndTime = dateStrArr[1]//结束日期
    },
    getMemberListPromise(params, parameter) {
      this.getLogUtils().logWithTag('==getMemberListPromise==', params)
      this.getLogUtils().logWithTag('==getMemberListPromise==parameter', parameter)
      this.updateByStatus(parameter)
      const newParams = {
        ...params,
        orderByPaidFeeCount: this.$store.getters.sortCount,
        orderByAccountWithdrawn: this.$store.getters.sortDrawn,
        orderByAccountAbleDrawCash: this.$store.getters.sortCash
      }
      console.error('newParams', newParams)
      this.getStaffTotalAmount(newParams)
      return this.getHttpServices().getUserService().post('staff/v2/getStaffList', newParams)
    },
    updateByStatus(query) {
      if (query && query.sortField) {
        if (query.sortField == 'paidFeeCount') {
          let type = query.sortOrder ? (query.sortOrder == 'ascend' ? 1 : 2) : undefined
          this.$store.commit('SET_FEE_COUNT', type)
          this.$store.commit('SET_WIDTH_DRAWN', undefined)
          this.$store.commit('SET_DRAWN_CASH', undefined)
        }
        if (query.sortField == 'accountWithdrawn') {
          let type = query.sortOrder ? (query.sortOrder == 'ascend' ? 1 : 2) : undefined
          this.$store.commit('SET_FEE_COUNT', undefined)
          this.$store.commit('SET_WIDTH_DRAWN', type)
          this.$store.commit('SET_DRAWN_CASH', undefined)
        }
        if (query.sortField == 'accountAbleDrawCash') {
          let type = query.sortOrder ? (query.sortOrder == 'ascend' ? 1 : 2) : undefined
          this.$store.commit('SET_FEE_COUNT', undefined)
          this.$store.commit('SET_WIDTH_DRAWN', undefined)
          this.$store.commit('SET_DRAWN_CASH', type)
        }
      }
    },
    getStaffTotalAmount(params) {
      this.getHttpServices().getUserService().post('staff/v2/getStaffTotalAmount', params).then(res => {
        this.getLogUtils().errorWithTag('getStaffTotalAmount', params)
        if (res) {
          this.totalForm = res
        } else {
          this.totalForm = {
            totalPaidFeeCount: 0,
            totalAccountWithdrawn: 0,
            totalAccountAbleDrawCash: 0
          }
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    timeOut() {
      this.$refs.pageList.refresh()
    },
    getStaffStatus() {
      this.getHttpServices().getUserService()
        .post('staff/v2/getStaffListRequestStatusItem')
        .then(list => {
          this.staffStatusList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    createMemberEvent() {
      this.openNewPage('CreateMember', {})
    },
    submitMemberAuthEvent() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择一个成员')
        return
      }
      if (this.selectedRowKeys.length > 1) {
        this.$message.warning('一次只能认证一个成员')
        return
      }
      this.openNewPage('SubmitMemberAuth', { staffId: this.selectedRowKeys[0] })
    },
    settingEvent() {
      this.$message.warn('暂不支持该功能')
    },
    toDetailEvent(record) {
      this.openNewPage('ShopDetail', { staffId: record.staffId })
    },
    toAuthDetailEvent(record) {
      this.openNewPage('MemberAuthDetail', { staffId: record.staffId })
    },
    toRecordEvent(record) {
      this.openNewPage('CommissionRecord', { staffId: record.staffId })
    },
    //更新状态
    updateStatus(record) {
      const params = {
        dsp: '',
        ids: record.staffId,
        newStatus: record.staffStatus === 0 ? 1 : 0
      }
      let tips = record.staffStatus === 0 ? '启用成功' : '禁用成功'
      this.getHttpServices().getUserService()
        .post('user/merchantStaff/batchChangeEnableStatus', params)
        .then(res => {
          this.$message.success(tips)
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 审核：跳转成员认证详情页底部操作
    auditEvent(record) {
      this.openNewPage('MemberAuthDetail', { staffId: record.staffId, needAudit: true })
      // 原弹窗审核逻辑
      // this.selectedItem = record
      // this.showAuditDialog = true
      // this.staffAudit = 1
      // setTimeout(() => {
      //   this.form.setFieldsValue({
      //     staffAudit: 1
      //   })
      // }, 500)
    },
    // onAuditStateChange(e) {
    //   this.staffAudit = e.target.value
    // },
    // handleAudit() {
    //   this.form.validateFieldsAndScroll((err, values) => {
    //     if (!err) {
    //       const params = {
    //         ...values,
    //         staffID: this.selectedItem.staffId
    //       }
    //       this.getHttpServices().getUserService().post('staff/v2/updateAuditStaff', params)
    //         .then(res => {
    //           this.showAuditDialog = false
    //           this.$message.success('审核成功')
    //           this.$refs.pageList.refresh()
    //         }).catch(reason => this.showNetWorkErrorMessage(reason))
    //     }
    //   })
    // },

    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'staffId'
        },
        {
          title: '店铺名称',
          dataIndex: 'staffShopName'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName',
          width: '12%',
          scopedSlots: { customRender: 'group' }
        },
        {
          title: '姓名/公司名',
          dataIndex: 'staffName',
          scopedSlots: { customRender: 'contactSlots' }
        },
        {
          title: '认证类型',
          dataIndex: 'staffAuthTypeStr'
        },
        {
          title: '认证状态',
          dataIndex: 'staffAuditStr'
        },
        {
          title: '销售统计',
          sorter: true,
          dataIndex: 'paidFeeCount'
        },
        {
          title: '累计提现金额(元)',
          sorter: true,
          dataIndex: 'accountWithdrawn'
        },
        {
          title: '可提现金额',
          sorter: true,
          dataIndex: 'accountAbleDrawCash'
        },
        {
          title: '状态',
          dataIndex: 'memberState',
          scopedSlots: { customRender: 'memberState' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '220px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGroupColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        }
      ]
    }
  }

}
</script>
<style lang="less">
@import "../../CustomPage";

.status-list-custom {
  background-color: #F5F5F6;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 8px;

  .heading {
    span {
      color: #FEA834;
    }

    .active {
      color: #f5222d;
    }

    i {
      font-size: 11px;
      font-style: normal;
    }
  }
}

.button-flex {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
}
</style>
<style lang='less' scoped>
.custom-page-box {
  position: relative;
}

.extra-pagination-fixed {
  position: fixed;
  left: 275px;
  bottom: 0px;
  z-index: 100;
  background: #FFFFFF;
  padding: 5px 24px;
  border-radius: 5px;
}

.ml10 {
  margin-left: 10px;
}

.footer-btns {
  text-align: right;
  padding-top: 20px;
}

.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>